import produce from 'immer';
import { actionTypes as dateRangePickerActionTypes, reducerValuesFunction as dateRangePickerReducerFunction } from '@components/Kendo/DateRangePickerReducer';
export const actionTypes = Object.assign({ LOADING_CHANGED: 'LOADING_CHANGED', DATA_LOADED: 'DATA_LOADED', PAGE_CHANGED: 'PAGE_CHANGED', SORT_CHANGED: 'SORT_CHANGED', FILTER_CHANGED: 'FILTER_CHANGED', FILTER_TOGGLED: 'FILTER_TOGGLED', COLUMNS_CHANGED: 'COLUMNS_CHANGED' }, dateRangePickerActionTypes);
export const reducer = produce((draft, action) => {
    if (Object.keys(dateRangePickerActionTypes).includes(action.type)) {
        dateRangePickerReducerFunction(draft, action);
        draft.page.skip = 0;
        return;
    }
    switch (action.type) {
        case actionTypes.LOADING_CHANGED:
            if (action.type === 'LOADING_CHANGED') {
                draft.loading = action.loading;
            }
            break;
        case actionTypes.DATA_LOADED:
            if (action.type === 'DATA_LOADED') {
                draft.data = action.data.data;
                draft.totalCount = action.data.total_count;
            }
            break;
        case actionTypes.PAGE_CHANGED:
            if (action.type === 'PAGE_CHANGED') {
                draft.page = action.page;
            }
            break;
        case actionTypes.SORT_CHANGED:
            if (action.type === 'SORT_CHANGED') {
                draft.sort = action.sort;
            }
            break;
        case actionTypes.FILTER_CHANGED:
            if (action.type === 'FILTER_CHANGED') {
                draft.filters = action.filters;
                draft.page = { skip: 0, take: draft.page.take };
            }
            break;
        case actionTypes.FILTER_TOGGLED:
            if (action.type === 'FILTER_TOGGLED') {
                const fieldKey = action.field;
                draft.filters.active[fieldKey] = !draft.filters.active[fieldKey];
                draft.page = { skip: 0, take: draft.page.take };
            }
            break;
        case actionTypes.COLUMNS_CHANGED:
            if (action.type === 'COLUMNS_CHANGED') {
                draft.columns = action.columns;
            }
            break;
        default:
            break;
    }
});
